import api from './api';
import { Playlist, PlaylistItem, CreatePlaylistRequest } from '../types/playlists';

export const playlistsApi = {
  getAllPlaylists: async (): Promise<Playlist[]> => {
    const response = await api.get('/playlists');
    return response.data;
  },

  getPlaylist: async (id: number): Promise<Playlist> => {
    const response = await api.get(`/playlists/${id}`);
    return response.data;
  },

  createPlaylist: async (playlist: CreatePlaylistRequest): Promise<Playlist> => {
    const response = await api.post('/playlists', playlist);
    return response.data;
  },

  updatePlaylist: async (id: number, playlist: Partial<Playlist>): Promise<Playlist> => {
    // Prepare the data for the backend, excluding playlistItemId and other unnecessary fields
    const playlistData = {
      playlistName: playlist.playlistName,
      active: playlist.active,
      playlistItems: playlist.playlistItems?.map(item => ({
        assetId: item.assetId,
        displayOrder: item.displayOrder,
        displayDuration: item.displayDuration ?? 30, // Use nullish coalescing for default
        active: item.active ?? true
        // Explicitly exclude playlistItemId and other fields
      }))
    };

    const response = await api.put(`/playlists/${id}`, playlistData);
    return response.data;
  },

  deletePlaylist: async (id: number): Promise<void> => {
    await api.delete(`/playlists/${id}`);
  },

  getPlaylistItems: async (playlistId: number): Promise<PlaylistItem[]> => {
    const response = await api.get(`/playlists/${playlistId}/items`);
    return response.data;
  },

  addPlaylistItem: async (playlistId: number, item: Omit<PlaylistItem, 'playlistItemId'>): Promise<PlaylistItem> => {
    const response = await api.post(`/playlists/${playlistId}/items`, item);
    return response.data;
  },

  updatePlaylistItems: async (playlistId: number, items: PlaylistItem[]): Promise<void> => {
    await api.put(`/playlists/${playlistId}/items`, items);
  },

  deletePlaylistItem: async (playlistId: number, itemId: number): Promise<void> => {
    await api.delete(`/playlists/${playlistId}/items/${itemId}`);
  },

  reorderPlaylistItems: async (playlistId: number, itemIds: number[]): Promise<void> => {
    await api.put(`/playlists/${playlistId}/items/reorder`, { itemIds });
  }
};